import * as React from 'react'
import { LOGOS } from 'gatsby-env-variables'
import { Conditional } from 'iq-blueberry'

import Img from 'components/common/Img'
import IqLogo from '../IqLogo'
import { useGetApplication } from 'hooks/useGetApplication'

interface IQBrandProps {
  isSmall?: boolean,
  isMedium?: boolean
}

const ApplicationBrand = ({
  isSmall = false,
  isMedium = false,
}: IQBrandProps) => {
  const { application } = useGetApplication()
  if (!application) return null

  const cpLogo = (
    <Conditional
      condition={isSmall}
      renderIf={<Img src="images/cp-logo-small.svg" />}
      renderElse={
        <Conditional
          condition={isMedium}
          renderIf={<Img src="images/cp-logo-medium.svg" />}
          renderElse={<Img src="images/cp-logo.svg" />}
        />
      }
    />
  )

  return (
    <Conditional
      condition={application === 'cp'}
      renderIf={cpLogo}
      renderElse={
        <Conditional
          condition={application === 'iq'}
          renderIf={<IqLogo />}
          renderElse={
            <Img src={LOGOS[application]} style={{ height: '32px' }} />
          }
        />
      }
    />
  )
}

export default ApplicationBrand
